(function () {
  'use strict';
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  // Klicks werden gesammelt und erst nach dieser Pause als ein Request geschickt.
  var COMMIT_DELAY = 350;
  var pending = new Map();
  function pendingState(widget) {
    var p = pending.get(widget);
    if (!p) {
      p = { timer: null, inFlight: false, rerun: false };
      pending.set(widget, p);
    }
    return p;
  }
  function isPending(widget) {
    var p = pending.get(widget);
    return !!(p && (p.timer || p.inFlight));
  }
  function getSectionsToRender() {
    return ['header', 'mega-menu-header'];
  }
  function applyCartResponse(res) {
    if (!res || !res.sections) return;
    Object.keys(res.sections).forEach(function (id) {
      var html = res.sections[id];
      if (!html) return;
      var current = document.getElementById('shopify-section-' + id);
      if (!current) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.getElementById('shopify-section-' + id);
      if (!fresh) return;
      current.innerHTML = fresh.innerHTML;
    });
    try {
      if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pg-atc', cartData: res });
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: res }));
  }
  function updateCartBadges(count) {
    if (count == null) return;
    document.querySelectorAll('.cart-btn .action-badge, [data-cart-count], .cart-count-bubble span:not([aria-hidden]), .cart-count, #CartCount').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble) bubble.classList.toggle('hidden', count === 0);
  }
  function expand(widget) {
    // Eingeklappter Zustand = Kreis (Widget) bzw. CTA-Leiste (Bar-Variante).
    var circle = $('[data-pg-atc-circle]', widget);
    if (!circle) return;
    circle.hidden = true;
    $('[data-pg-atc-expanded]', widget).hidden = false;
  }
  function collapse(widget) {
    var circle = $('[data-pg-atc-circle]', widget);
    if (!circle) return;
    circle.hidden = false;
    $('[data-pg-atc-expanded]', widget).hidden = true;
  }
  function showQtyView(widget, qty) {
    $('[data-pg-atc-view="text"]', widget).hidden = true;
    $('[data-pg-atc-view="qty"]', widget).hidden  = false;
    $('[data-pg-atc-count]', widget).textContent = qty;
  }
  function showTextView(widget) {
    $('[data-pg-atc-view="text"]', widget).hidden = false;
    $('[data-pg-atc-view="qty"]', widget).hidden  = true;
    $('[data-pg-atc-count]', widget).textContent = '1';
  }
  function applyQty(widget, qty) {
    if (qty > 0) {
      widget.dataset.inCart = 'true';
      widget.dataset.qty = String(qty);
      showQtyView(widget, qty);
    } else {
      widget.dataset.inCart = 'false';
      widget.dataset.qty = '0';
      showTextView(widget);
    }
  }
  function getMax(widget) {
    var m = parseInt(widget.dataset.max || '', 10);
    if (isNaN(m)) return Infinity;
    return m < 0 ? 0 : m;
  }
  function fetchCart() {
    return fetch(getRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function findItem(cart, variantId) {
    return cart.items.find(function (i) {
      return String(i.variant_id) === String(variantId);
    });
  }
  function cartAdd(variantId, quantity) {
    return fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: quantity }],
        sections: getSectionsToRender(),
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      if (!r.ok) {
        var err = new Error('cart/add failed');
        err.status = r.status;
        throw err;
      }
      return r.json();
    });
  }
  function cartChange(itemKey, quantity) {
    return fetch(getRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity,
        sections: getSectionsToRender(),
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      if (!r.ok) {
        var err = new Error('cart/change failed');
        err.status = r.status;
        throw err;
      }
      return r.json();
    });
  }
  function setDesired(widget, qty) {
    if (qty < 0) qty = 0;
    var max = getMax(widget);
    if (qty > max) qty = max;
    applyQty(widget, qty);
    scheduleCommit(widget);
  }
  function scheduleCommit(widget) {
    var p = pendingState(widget);
    if (p.timer) clearTimeout(p.timer);
    p.timer = setTimeout(function () {
      p.timer = null;
      commit(widget);
    }, COMMIT_DELAY);
  }
  function commit(widget) {
    var p = pendingState(widget);
    if (p.inFlight) {
      p.rerun = true;
      return;
    }
    var variantId = widget.dataset.variantId;
    if (!variantId) return;
    var desired = parseInt(widget.dataset.qty || '0', 10);
    p.inFlight = true;
    p.rerun = false;
    var opError = null;
    fetchCart().then(function (cart) {
      var item = findItem(cart, variantId);
      var current = item ? item.quantity : 0;
      if (current === desired) return null;
      if (item) return cartChange(item.key, desired);
      if (desired > 0) return cartAdd(variantId, desired);
      return null;
    }).then(function (res) {
      if (res) applyCartResponse(res);
    }).catch(function (err) {
      opError = err;
      console.error('[pg-atc]', err);
    }).then(function () {
      return fetchCart();
    }).then(function (cart) {
      updateCartBadges(cart.item_count);
      p.inFlight = false;
      // Wurde während des Requests weitergeklickt, übernimmt der nächste Commit.
      if (p.timer || p.rerun) {
        if (p.rerun) {
          p.rerun = false;
          commit(widget);
        }
        return;
      }
      var item = findItem(cart, variantId);
      var actual = item ? item.quantity : 0;
      var desiredNow = parseInt(widget.dataset.qty || '0', 10);
      if (actual < desiredNow) {
        // Shopify hat gekappt (Lagerbestand erreicht) — außer der Request ist
        // technisch fehlgeschlagen, dann kein Limit merken.
        var stockCapped = !opError || opError.status === 422;
        if (stockCapped) widget.dataset.max = String(actual);
      }
      applyQty(widget, actual);
    }).catch(function (err) {
      p.inFlight = false;
      console.error('[pg-atc]', err);
    });
  }
  function syncWidgetsWithCart() {
    var widgets = $$('[data-pg-atc]');
    if (!widgets.length) return;
    fetchCart().then(function (cart) {
      updateCartBadges(cart.item_count);
      widgets.forEach(function (widget) {
        if (isPending(widget)) return;
        var variantId = widget.dataset.variantId;
        if (!variantId) return;
        var item = findItem(cart, variantId);
        applyQty(widget, item ? item.quantity : 0);
      });
    });
  }
  document.addEventListener('click', function (e) {
    var widget = e.target.closest('[data-pg-atc]');
    if (!widget) return;
    var actionEl = e.target.closest('[data-pg-atc-action]');
    if (!actionEl) return;
    e.preventDefault();
    e.stopPropagation();
    var action = actionEl.dataset.pgAtcAction;
    var qty = parseInt(widget.dataset.qty || '0', 10);
    if (action === 'add')        setDesired(widget, 1);
    if (action === 'increment')  setDesired(widget, qty + 1);
    if (action === 'decrement')  setDesired(widget, qty - 1);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var actionEl = e.target.closest('[data-pg-atc-action]');
    if (!actionEl) return;
    var widget = actionEl.closest('[data-pg-atc]');
    if (!widget) return;
    e.preventDefault();
    actionEl.click();
  });
  document.addEventListener('mouseover', function (e) {
    var widget = e.target.closest('[data-pg-atc]');
    if (widget) expand(widget);
  });
  document.addEventListener('mouseout', function (e) {
    var widget = e.target.closest('[data-pg-atc]');
    if (!widget) return;
    if (widget.contains(e.relatedTarget)) return;
    collapse(widget);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncWidgetsWithCart);
  } else {
    syncWidgetsWithCart();
  }
  document.addEventListener('cart:refresh', syncWidgetsWithCart);
  document.addEventListener('cart:updated', syncWidgetsWithCart);
})();
